import React from 'react';
import { motion } from 'framer-motion';
import { Clock, MessageCircle, SunMoon, CalendarDays } from 'lucide-react';
const bonuses = [{
  title: 'Kit Express de Crisis en 5 Minutos',
  subtitle: 'Bono 1',
  desc: 'El protocolo claro para actuar en medio de un desborde sin empeorarlo.',
  icon: Clock
}, {
  title: 'Guiones Calmos para Momentos Difíciles',
  subtitle: 'Bono 2',
  desc: 'Frases exactas para hablar con tu hijo cuando no sabés qué decir.',
  icon: MessageCircle
}, {
  title: 'Rutina Anticaos de Mañana y Noche',
  subtitle: 'Bono 3',
  desc: 'Secuencias listas para bajar fricción en vestirse, salir y dormir.',
  icon: SunMoon
}, {
  title: 'Tablero Maestro de la Semana en Calma',
  subtitle: 'Regalo Especial',
  desc: 'Planificadores, checklists y tableros imprimibles para organizar toda la semana en un solo sistema.',
  icon: CalendarDays,
  isGift: true
}];
export function Bonuses() {
  return <section className="py-20 bg-white" data-id="element-11">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-14">
            3 bonos incluidos + 1 regalo especial
          </h2>
          <p className="text-lg text-gray-600" data-id="element-15">
            Todo pensado para que no solo entiendas qué hacer, sino que ya lo
            tengas listo para aplicar.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-16">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`p-8 rounded-3xl border relative overflow-hidden ${bonus.isGift ? 'bg-ocean-gold-light/30 border-ocean-gold/20' : 'bg-ocean-cream border-gray-100'}`} data-id="element-17">
              <div className="flex items-start gap-4" data-id="element-18">
                <div className={`p-3 rounded-xl ${bonus.isGift ? 'bg-ocean-gold/10 text-ocean-gold-dark' : 'bg-ocean-teal/10 text-ocean-teal'}`} data-id="element-19">
                  <bonus.icon className="w-6 h-6" data-id="element-20" />
                </div>
                <div data-id="element-21">
                  <div className={`text-sm font-bold uppercase tracking-wider mb-1 ${bonus.isGift ? 'text-ocean-gold-dark' : 'text-ocean-teal'}`} data-id="element-22">
                    {bonus.subtitle}
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-gray-900" data-id="element-23">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-24">{bonus.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}